import { Eyebrow } from '../brand';
import { FAQ_COUNT, faqEntries } from '../i18n';
import { useLang } from '../lang';

export function Faq({ prefix = 'faq', count = FAQ_COUNT }: { prefix?: string; count?: number }) {
  const { t, lang } = useLang();
  return (
    <section className="band band-soft faq" id="faq" aria-labelledby={`${prefix}-title`}>
      <div className="frame faq-grid">
        <header className="faq-head" data-reveal>
          <Eyebrow k="faq.eyebrow" />
          <h2 id={`${prefix}-title`} className="h2">
            {t('faq.title')}
          </h2>
        </header>
        <div className="faq-list" data-reveal>
          {faqEntries(lang, prefix, count).map((item, i) => (
            <details key={i} name={prefix}>
              <summary>
                <span>{item.q}</span>
                <span className="faq-sign" aria-hidden="true" />
              </summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
